import { FreeSaleStatus, I18nSelector } from '../types';

const freeSaleTexts: Record<FreeSaleStatus, I18nSelector> = {
	open: i18n => i18n.freeSale.open,
	closed: i18n => i18n.freeSale.closed,
	notEnoughSold: i18n => i18n.freeSale.notEnoughSold as unknown as string,
};

export default freeSaleTexts;